import React from 'react';
import { Helmet } from 'react-helmet-async';
import RelatedLinks from '../components/RelatedLinks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faCheck, faCommentDots, faMobileAlt } from '@fortawesome/free-solid-svg-icons';
import { faWeibo, faWeixin } from '@fortawesome/free-brands-svg-icons';
import './Contact.css';
import { getImageUrl, getSrcSet } from '../utils/imageUrl';

const Contact: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>联系我们 | 预约德国展会翻译与现场协助 | 法兰克福、汉诺威、科隆</title>
        <meta name="description" content="立即联系DECN德中展会服务团队，预约法兰克福、汉诺威、科隆等德国各大城市的高质量展会翻译与现场协助服务。支持微信及邮件快速咨询，资深留学生为您提供专业支持。" />
        <meta name="keywords" content="德国展会翻译联系, 法兰克福展会翻译预约, 德国翻译微信, 德国展会协助, 展会翻译价格, 德国留学生翻译联系" />
        <link rel="canonical" href="https://decn-exhibition.top/contact" />
      </Helmet>
      
      <section className="page-header contact-header" style={{
        background: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('${getImageUrl('/images/kontakt.jpg', { width: 1600, format: 'webp', quality: 70 })}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        padding: '120px 0 60px',
        color: '#fff',
        textAlign: 'center'
      }}>
        <div className="container">
          <h1>联系我们</h1>
          <p>高效沟通，为您在德国的展出提供即时支持</p>
        </div>
      </section>

      <section className="contact-page">
        <div className="container">
          <div className="contact-container-simplified">
            <div className="contact-methods">
              <div className="contact-method-card main-contact">
                <div className="method-icon">
                  <FontAwesomeIcon icon={faWeixin} />
                </div>
                <h2>微信快速咨询</h2>
                <p>扫描下方二维码或搜索微信号添加，获取最及时的服务响应与报价</p>
                <div className="qrcode-wrapper">
                  <img
                    src={getImageUrl('/images/Wechat.jpg', { width: 250, format: 'webp', quality: 80 })}
                    alt="DECN德中展会服务微信二维码"
                    className="contact-qrcode"
                  />
                </div>
                <div className="wechat-id">
                  <span>微信号：<strong>LouisNERO</strong></span>
                </div>
                <p className="contact-hint">（添加时请备注：德国展会服务咨询）</p>
              </div>

              <div className="contact-method-card secondary-contact">
                <div className="method-icon">
                  <FontAwesomeIcon icon={faEnvelope} />
                </div>
                <h2>邮件联系</h2>
                <p>如需发送详细的需求文档或展品资料，请发送至：</p>
                <a href="mailto:info@decn-exhibition.top" className="email-link">
                  info@decn-exhibition.top
                </a>
                <p className="contact-hint">我们会在24小时内回复您的邮件</p>
              </div>
            </div>
            
            <div className="contact-info-footer">
              <div className="service-assurance">
                <h3>服务保障与说明</h3>
                <div className="assurance-grid">
                  <div className="assurance-item">
                    <FontAwesomeIcon icon={faCheck} />
                    <span><strong>专业匹配</strong>：根据行业背景指派译员</span>
                  </div>
                  <div className="assurance-item">
                    <FontAwesomeIcon icon={faCheck} />
                    <span><strong>极速响应</strong>：工作日24小时内答复</span>
                  </div>
                  <div className="assurance-item">
                    <FontAwesomeIcon icon={faCheck} />
                    <span><strong>本地资源</strong>：覆盖全德所有主要展会城市</span>
                  </div>
                  <div className="assurance-item">
                    <FontAwesomeIcon icon={faCheck} />
                    <span><strong>价格透明</strong>：确认需求后即时提供报价</span>
                  </div>
                </div>
                <p className="booking-tip">温馨提示：为了确保能为您安排到最合适的专业译员，建议您至少提前2周进行预约。</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <RelatedLinks currentPage="/contact" />
    </>
  );
};

export default Contact;